import * as XLSX from "xlsx"

export interface ExportColumn<T> {
  header: string
  accessor: (row: T) => string | number | null | undefined
}

export function exportToExcel<T>(
  data: T[],
  columns: ExportColumn<T>[],
  filename: string,
  sheetName = "Sheet1",
) {
  const headers = columns.map((col) => col.header)
  const rows = data.map((row) =>
    columns.map((col) => {
      const value = col.accessor(row)
      return value ?? ""
    }),
  )

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows])

  // Auto-size columns based on content width
  const colWidths = columns.map((col, i) => {
    const maxLen = Math.max(
      col.header.length,
      ...rows.map((r) => String(r[i] ?? "").length),
    )
    return { wch: Math.min(maxLen + 2, 50) }
  })
  worksheet["!cols"] = colWidths

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)
  XLSX.writeFile(workbook, `${filename}.xlsx`)
}
